import React, { useCallback } from 'react'
import { Alert } from 'components'
import { useAlert } from 'components/Alerts/hooks'
import { alerts as alertKeys } from 'keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteAssessmentFetch } from 'store/middlewares/assessment.crud'
import { useSelector } from 'react-redux'
import { queryClient as qc } from 'keys'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { deleteTicketFetch } from 'store/middlewares/tickets.crud'

const RemoveTicketAlert = () => {
    const { alerts } = useSelector(state => state.general)
    const { setAlerts } = useAlert()
    const queryClient = useQueryClient()

    const { mutateAsync: deleteTicket } = useMutation({
        mutationFn: deleteTicketFetch,
        onSuccess: () => {
            handleClose()
            queryClient.invalidateQueries([qc.ticket])
        },
        onError: () => {
            handleClose()
            toast.error("בעייה במחיקה", toastConfig)
        }
    })

    const handleClose = useCallback(() => {
        setAlerts(alertKeys.removeTicket, false)
    }, [])

    const removeTicket = useCallback(() => {
        deleteTicket(alerts.removeTicket.props)
    }, [])

    const footerActions = React.useMemo(
        () => [
            { label: "ביטול", color: "thirdly4", action: handleClose },
            { label: "מחיקה", color: "error", action: removeTicket }
        ], []
    )

    return (
        <Alert
            systemUI
            type="danger"
            title={" האם את בטוחה שאת רוצה למחוק את הפניה?"}
            footerActions={footerActions}
            handleAlert={handleClose}
        >
            {"מחיקת הפניה תמחק את הפניה לצמיתות"}
        </Alert>
    )
}

export default RemoveTicketAlert